export const businessHeaders = [
  { header: 'agencyName', label: 'Agency Name' },
  { header: 'aggregatorID', label: 'Node' },
  { header: 'partnerName', label: 'Partner Name' },
  { header: 'visitType', label: 'Visit Type' },
  { header: 'totalTransactions', label: 'Total Transactions' },
  { header: 'totalSuccess', label: 'Total Success' },
  { header: 'totalErrors', label: 'Total Errors' },
  { header: 'totalPending', label: 'Total Pending' },
];

export const visitStatusLabels = {
  CD: 'Cancelled',
  CP: 'Completed',
  FN: 'Finished',
  PR: 'In Progress',
  MV: 'Missed',
  SC: 'Scheduled',
  VD: 'Voided',
  '': '',
};

export const visitTypeOptions = [
  { label: 'All', value: 'ALL' },
  { label: 'Cancelled', value: 'CD' },
  { label: 'Completed', value: 'CP' },
  { label: 'Finished', value: 'FN' },
  { label: 'In Progress', value: 'PR' },
  { label: 'Missed', value: 'MV' },
  { label: 'Scheduled', value: 'SC' },
  { label: 'Voided', value: 'VD' },
];
